import React, { useState, useEffect, useContext } from "react";
import { deleteUser, getAllUsers, createUser, updateUser } from "../../business/UserBusiness";
import { AuthContext } from "../../context/Auth";
import { Link } from "react-router-dom";
import { FaRegTrashAlt, FaRegEye, FaEdit } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import { Sidebar } from '../../components/Sidebar';
import { updateSubscription } from "../../business/AdminBusiness";
import toast from "react-hot-toast";

export const Home = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const [selectedDelete, setSelectedDelete] = useState(null)
  const [selectedDeleteUser, setSelectedDeleteUser] = useState(null)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editingUser, setEditingUser] = useState(null)
  const [newUser, setNewUser] = useState({
    username: '',
    email: '',
    phone: '',
    password: '',
    role: 'user'
  })
  const [sortBy, setSortBy] = useState('createdAt'); // 'createdAt', 'username', 'transactions'
  const [sortOrder, setSortOrder] = useState('desc'); // 'asc' ou 'desc'

  const adminName = localStorage.getItem("@Auth:name")
  const { user } = useContext(AuthContext);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await getAllUsers();
      console.log(response);
      setUsers(response?.data || []);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const confirmDeleteImage = async (imageId) => {
    try {
        // Função removida pois não existe mais no novo backend
        toast.success('Funcionalidade de exclusão de imagem não disponível no novo backend');
        setSelectedDelete(null)
    } catch (error) {
        console.error('Erro ao excluir imagem do usuário:', error)
    }
}

const confirmDeleteUser = async (userId) => {
  try {
      await deleteUser(userId);      
      // Atualiza o estado de user.user.images para remover a imagem excluída
      toast.success('Usuário foi removido com sucesso!');
      setSelectedDeleteUser(null)

  } catch (error) {
      console.error('Erro ao excluir conta do usuário:', error);
      toast.error('Erro ao deletar conta de usuário')
  }

};

  const filteredUsers = users?.filter((user) => {
    const matchesSearch = user?.username?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                         user?.email?.toLowerCase().includes(searchTerm?.toLowerCase());
    
    const matchesRole = roleFilter === "all" || user?.role === roleFilter;
    
    return matchesSearch && matchesRole;
  });

  // Ordenar usuários
  const sortedUsers = filteredUsers?.sort((a, b) => {
    if (sortBy === 'username') {
      const nameA = a.username?.toLowerCase() || '';
      const nameB = b.username?.toLowerCase() || '';
      return sortOrder === 'asc' ? nameA.localeCompare(nameB) : nameB.localeCompare(nameA);
    } else if (sortBy === 'createdAt') {
      const dateA = new Date(a.createdAt || 0);
      const dateB = new Date(b.createdAt || 0);
      return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
    } else if (sortBy === 'transactions') {
      const transactionsA = a.transactions?.length || 0;
      const transactionsB = b.transactions?.length || 0;
      return sortOrder === 'asc' ? transactionsA - transactionsB : transactionsB - transactionsA;
    } else if (sortBy === 'lastLogin') {
      const lastLoginA = new Date(a.lastUserRequest || a.createdAt || 0);
      const lastLoginB = new Date(b.lastUserRequest || b.createdAt || 0);
      return sortOrder === 'asc' ? lastLoginA - lastLoginB : lastLoginB - lastLoginA;
    }
    return 0;
  });

  const handleSearchTerm = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleRoleFilter = (e) => {
    setRoleFilter(e.target.value);
  };

  const handleSortChange = (newSortBy) => {
    if (sortBy === newSortBy) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(newSortBy);
      setSortOrder('desc'); // Sempre começar pelo mais recente
    }
  };

  const handleUpdateSubscription = async (subscriptionValue) => {
    try{
      await updateSubscription(selectedUserId, {subscription: subscriptionValue})
      toast.success('Pronto! Atualize a página para ver as alterações')
    } catch (err) {
      toast.error('Erro ' + err)
      console.log(err)
    }
  }

  const handlePersonClick = (person) => {
    setSelectedPerson(person);
    setSelectedUserId(person?._id)
  };

  const handleEditClick = (e, person) => {
    e.stopPropagation(); // Evita que o clique propague para a linha
    setEditingUser({
      _id: person._id,
      username: person.username,
      email: person.email || '',
      phone: person.phone || '',
      role: person.role || 'user',
      subscription: person.subscription || 'inactive'
    });
    setShowEditModal(true);
  };

  console.log(selectedUserId)

  const handleModalClose = () => {
    setSelectedPerson(null);
  };

  const handleEditModalClose = () => {
    setShowEditModal(false);
    setEditingUser(null);
  };

  const handleEditUser = async () => {
    try {
      if (!editingUser.email || !editingUser.phone) {
        toast.error('Por favor, preencha todos os campos obrigatórios');
        return;
      }

      setIsLoading(true);
      
      // Preparar dados para atualização
      const updateData = {
        email: editingUser.email,
        phone: editingUser.phone,
        role: editingUser.role,
        subscription: editingUser.subscription
      };

      await updateUser(editingUser._id, updateData);
      toast.success('Usuário atualizado com sucesso!');
      
      setShowEditModal(false);
      setEditingUser(null);
      fetchUsers(); // Recarregar lista
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      toast.error(error?.response?.data?.msg || 'Erro ao atualizar usuário');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditInputChange = (field, value) => {
    setEditingUser(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const formatCreatedAt = (createdAt) => {
    const createdAtDate = new Date(createdAt);
    return createdAtDate.toLocaleDateString("pt-BR", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatLastLogin = (lastLogin) => {
    if (!lastLogin) return 'Nunca';
    const lastLoginDate = new Date(lastLogin);
    return lastLoginDate.toLocaleDateString("pt-BR", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "America/Sao_Paulo"
    });
  };

  const getRoleLabel = (role) => {
    switch(role) {
      case 'admin': return 'Administrador';
      case 'user': return 'Usuário';
      case 'patner': return 'Parceiro';
      case 'trial': return 'Trial';
      default: return role;
    }
  };

  const getRoleColor = (role) => {
    switch(role) {
      case 'admin': return 'bg-red-100 text-red-800';
      case 'user': return 'bg-blue-100 text-blue-800';
      case 'patner': return 'bg-green-100 text-green-800';
      case 'trial': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Função para gerar iniciais do username
  const getInitials = (username) => {
    if (!username) return '?';
    const names = username.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
  };

  // Função para gerar cor baseada no username
  const getAvatarColor = (username) => {
    if (!username) return 'bg-gray-500';
    const colors = [
      'bg-red-500',
      'bg-blue-500', 
      'bg-green-500',
      'bg-yellow-500',
      'bg-purple-500',
      'bg-pink-500',
      'bg-indigo-500',
      'bg-teal-500'
    ];
    const index = username.charCodeAt(0) % colors.length;
    return colors[index];
  };

  const handleCreateUser = async () => {
    try {
      if (!newUser.username || !newUser.email || !newUser.phone || !newUser.password) {
        toast.error('Por favor, preencha todos os campos obrigatórios');
        return;
      }

      setIsLoading(true);
      await createUser(newUser);
      toast.success('Usuário criado com sucesso!');
      
      setShowCreateModal(false);
      setNewUser({
        username: '',
        email: '',
        phone: '',
        password: '',
        role: 'user'
      });
      fetchUsers(); // Recarregar lista
    } catch (error) {
      console.error('Erro ao criar usuário:', error);
      toast.error(error?.response?.data?.msg || 'Erro ao criar usuário');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (field, value) => {
    setNewUser(prev => ({
      ...prev,
      [field]: value
    }));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      <div className="flex flex-col lg:flex-row">
        <Sidebar />
        <div className="flex-1 min-h-screen bg-white">
          <div className="max-w-7xl w-full mx-auto py-6 px-2 sm:px-4">
            {/* Cabeçalho e filtros */}
            <div className="mb-4">
              <h1 className="text-lg lg:text-xl font-light leading-6">Olá, <span className="font-bold">{adminName}</span></h1>
              <p className="text-base lg:text-lg font-light leading-6 text-gray-700">Dashboard - Todos os Usuários</p>
            </div>
            {/* Filtros e busca */}
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-4 space-y-4 lg:space-y-0">
              <label
                htmlFor="name"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Pesquise por username ou email ({sortedUsers?.length || 0} usuários)
              </label>
              <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-2 lg:space-y-0 lg:space-x-4 w-full lg:w-auto">
                <button
                  onClick={() => setShowCreateModal(true)}
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded w-full lg:w-auto"
                >
                  Criar usuário
                </button>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-4 mb-4">
              <div className="flex-1">
                <input
                  type="text"
                  name="name"
                  id="name"
                  className="block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  placeholder="Digite um username ou email..."
                  onChange={handleSearchTerm}
                  value={searchTerm}
                />
              </div>
              <div className="w-full lg:w-48">
                <select
                  value={roleFilter}
                  onChange={handleRoleFilter}
                  className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                >
                  <option value="all">Todos os roles</option>
                  <option value="user">Usuário</option>
                  <option value="admin">Administrador</option>
                  <option value="patner">Parceiro</option>
                  <option value="trial">Trial</option>
                </select>
              </div>
            </div>

            {/* Tabela responsiva */}
            <div className="overflow-x-auto">
              <table className="divide-y divide-gray-100 w-full">
                  <thead>
                      <tr className="bg-gray-100">
                          <th 
                              className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-200 transition-colors"
                              onClick={() => handleSortChange('username')}
                          >
                              <div className="flex items-center">
                                  Username
                                  {sortBy === 'username' && (
                                      <span className="ml-1 text-gray-400">
                                          {sortOrder === 'asc' ? '↑' : '↓'}
                                      </span>
                                  )}
                              </div>
                          </th>
                          <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden md:table-cell">Email</th>
                          <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Telefone</th>
                          <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                          <th className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden lg:table-cell">Premium</th>
                          <th 
                            className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-200 transition-colors"
                            onClick={() => handleSortChange('transactions')}
                          >
                            <div className="flex items-center">
                              Transações
                              {sortBy === 'transactions' && (
                                <span className="ml-1 text-gray-400">
                                  {sortOrder === 'asc' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden xl:table-cell cursor-pointer hover:bg-gray-200 transition-colors"
                            onClick={() => handleSortChange('createdAt')}
                          >
                            <div className="flex items-center">
                              Criado em
                              {sortBy === 'createdAt' && (
                                <span className="ml-1 text-gray-400">
                                  {sortOrder === 'asc' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th 
                            className="px-3 lg:px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider hidden xl:table-cell cursor-pointer hover:bg-gray-200 transition-colors"
                            onClick={() => handleSortChange('lastLogin')}
                          >
                            <div className="flex items-center">
                              Último uso
                              {sortBy === 'lastLogin' && (
                                <span className="ml-1 text-gray-400">
                                  {sortOrder === 'asc' ? '↑' : '↓'}
                                </span>
                              )}
                            </div>
                          </th>
                          <th className="px-3 lg:px-6 py-3"></th>
                      </tr>
                  </thead>
                  <tbody>
                      {isLoading ? (
                          <tr>
                              <td colSpan="9" className="py-4 px-6 text-center">Carregando...</td>
                          </tr>
                      ) : (

                        sortedUsers && sortedUsers.length > 0 ? (
                          sortedUsers?.map((person) => (
                            <tr
                                key={person?.email}
                                className="hover:bg-gray-100 cursor-pointer"
                                onClick={() => handlePersonClick(person)}
                            >
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div className="flex-shrink-0 h-8 w-8 lg:h-12 lg:w-12">
                                            <div className={`h-8 w-8 lg:h-12 lg:w-12 rounded-full flex items-center justify-center text-white font-semibold text-sm lg:text-lg ${getAvatarColor(person?.username)}`}>
                                                {getInitials(person?.username)}
                                            </div>
                                        </div>
                                          <div className="ml-2 lg:ml-4">
                                             <div className="text-xs lg:text-sm font-medium text-gray-900 truncate max-w-[80px] lg:max-w-[100px]">{person?.username}</div>
                                         </div>
                                    </div>
                                </td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap hidden md:table-cell">
                                    <div className="text-xs lg:text-sm text-gray-900 truncate max-w-[150px]">{person?.email}</div>
                                </td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap hidden lg:table-cell">
                                    <div className="text-xs lg:text-sm text-gray-900">{person?.phone}</div>
                                </td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap">
                                    <span className={`inline-flex items-center px-2 py-0.5 lg:px-2.5 lg:py-0.5 rounded-full text-xs font-medium ${getRoleColor(person?.role)}`}>
                                        {getRoleLabel(person?.role)}
                                    </span>
                                </td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500 hidden lg:table-cell">{person?.subscription === 'active' ? 'Sim' : 'Não'}</td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500">
                                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                        {person?.transactions?.length || 0}
                                    </span>
                                </td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500 hidden xl:table-cell">{formatCreatedAt(person?.createdAt)}</td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-xs lg:text-sm text-gray-500 hidden xl:table-cell">{formatLastLogin(person?.lastUserRequest)}</td>
                                <td className="px-3 lg:px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    <div className="flex items-center space-x-1 lg:space-x-2">
                                        <div
                                            className={`text-gray-900 ${person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'opacity-50 cursor-not-allowed' : 'hover:text-indigo-600 cursor-pointer'}`}
                                            onClick={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? undefined : (e) => handleEditClick(e, person)}
                                            title={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'Somente o próprio Alexandre pode editar' : 'Editar'}
                                        >
                                            <FaEdit size={14} className="lg:w-4 lg:h-4" color="blue"/>
                                        </div>
                                        <div
                                            className={`text-gray-900 ${person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'opacity-50 cursor-not-allowed' : 'hover:text-indigo-600 cursor-pointer'}`}
                                            onClick={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? undefined : () => {
                                              if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
                                                confirmDeleteUser(person?._id);
                                                handleModalClose();
                                              }
                                            }}
                                            title={person.email === 'alexandresaintss@gmail.com' && user?.email !== 'alexandresaintss@gmail.com' ? 'Somente o próprio Alexandre pode excluir' : 'Excluir'}
                                        >
                                            <FaRegTrashAlt size={14} className="lg:w-4 lg:h-4" color="red"/>
                                        </div>
                                        <div className="text-gray-900 hover:text-indigo-600 cursor-pointer">
                                            <FaRegEye size={14} className="lg:w-4 lg:h-4" color="grey-500"/>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="py-4 px-6 text-center">Nenhum usuário encontrado</td>
                          </tr>
                        )
                      )}
                  </tbody>
              </table>
            </div>

            {/* Modal de criação de usuário */}
            {showCreateModal && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center p-4">
                <div className="bg-white p-4 lg:p-8 rounded-lg w-full max-w-sm lg:max-w-md max-h-screen overflow-y-auto">
                  <div className="flex justify-between items-center mb-4 lg:mb-6">
                    <h2 className="text-lg lg:text-xl font-semibold">Criar Novo Usuário</h2>
                    <button
                      onClick={() => setShowCreateModal(false)}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      ✕
                    </button>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                      Username *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="username" 
                      type="text" 
                      placeholder="joao_silva" 
                      value={newUser.username}
                      onChange={(e) => handleInputChange('username', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                      Email *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="email" 
                      type="email" 
                      placeholder="joao@email.com" 
                      value={newUser.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <small>Lembre-se do código do país na frente</small>
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="phone">
                      Telefone *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="phone" 
                      type="tel" 
                      placeholder="(11) 99999-9999" 
                      value={newUser.phone}
                      onChange={(e) => handleInputChange('phone', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                      Senha *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="password" 
                      type="password" 
                      placeholder="********" 
                      value={newUser.password}
                      onChange={(e) => handleInputChange('password', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="role">
                      Role *
                    </label>
                    <select 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="role" 
                      value={newUser.role}
                      onChange={(e) => handleInputChange('role', e.target.value)}
                    >
                      <option value="user">Usuário</option>
                      <option value="admin">Administrador</option>
                      <option value="patner">Parceiro</option>
                      <option value="trial">Trial</option>
                    </select>
                  </div>
                  
                  <div className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2">
                    <button 
                      className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={handleCreateUser}
                      disabled={isLoading}
                    >
                      {isLoading ? 'Criando...' : 'Criar Usuário'}
                    </button>
                    <button 
                      className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={() => setShowCreateModal(false)}
                      disabled={isLoading}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Modal de edição de usuário */}
            {showEditModal && editingUser && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center p-4">
                <div className="bg-white p-4 lg:p-8 rounded-lg w-full max-w-sm lg:max-w-md max-h-screen overflow-y-auto">
                  <div className="flex justify-between items-center mb-4 lg:mb-6">
                    <h2 className="text-lg lg:text-xl font-semibold">Editar Usuário</h2>
                    <button
                      onClick={handleEditModalClose}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      ✕
                    </button>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-username">
                      Username
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 bg-gray-100" 
                      id="edit-username" 
                      type="text" 
                      value={editingUser.username}
                      disabled
                    />
                    <p className="text-xs text-gray-500 mt-1">Username não pode ser alterado</p>
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-email">
                      Email *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="edit-email" 
                      type="email" 
                      placeholder="joao@email.com" 
                      value={editingUser.email}
                      onChange={(e) => handleEditInputChange('email', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <small>Lembre-se do código do país na frente</small>
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-phone">
                      Telefone *
                    </label>
                    <input 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="edit-phone" 
                      type="tel" 
                      placeholder="(11) 99999-9999" 
                      value={editingUser.phone}
                      onChange={(e) => handleEditInputChange('phone', e.target.value)}
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-role">
                      Role *
                    </label>
                    <select 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="edit-role" 
                      value={editingUser.role}
                      onChange={(e) => handleEditInputChange('role', e.target.value)}
                    >
                      <option value="user">Usuário</option>
                      <option value="admin">Administrador</option>
                      <option value="patner">Parceiro</option>
                      <option value="trial">Trial</option>
                    </select>
                  </div>
                  
                  <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="edit-subscription">
                      Status de Subscription *
                    </label>
                    <select 
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      id="edit-subscription" 
                      value={editingUser.subscription}
                      onChange={(e) => handleEditInputChange('subscription', e.target.value)}
                    >
                      <option value="active">Ativo</option>
                      <option value="inactive">Inativo</option>
                    </select>
                  </div>
                  
                  <div className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2">
                    <button 
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={handleEditUser}
                      disabled={isLoading}
                    >
                      {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                    </button>
                    <button 
                      className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={handleEditModalClose}
                      disabled={isLoading}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Modal de visualização */}
            {selectedPerson && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center p-4">
                <div className="bg-white p-4 lg:p-8 rounded-lg w-full max-w-sm lg:max-w-md max-h-screen overflow-y-auto">
                  <div className="flex justify-between items-center mb-4 lg:mb-6">
                    <h2 className="text-lg lg:text-xl font-semibold">Detalhes do Usuário</h2>
                    <button
                      onClick={handleModalClose}
                      className="text-gray-500 hover:text-gray-700"
                    >
                      ✕
                    </button>
                  </div>
                  
                  {/* Avatar e informações principais */}
                  <div className="flex items-center mb-4 lg:mb-6">
                    <div className={`h-12 w-12 lg:h-16 lg:w-16 rounded-full flex items-center justify-center text-white font-semibold text-lg lg:text-2xl ${getAvatarColor(selectedPerson?.username)}`}>
                      {getInitials(selectedPerson?.username)}
                    </div>
                    <div className="ml-3 lg:ml-4">
                      <h3 className="text-base lg:text-lg font-semibold">{selectedPerson?.username}</h3>
                      <span className={`inline-flex items-center px-2 py-0.5 lg:px-2.5 lg:py-0.5 rounded-full text-xs font-medium ${getRoleColor(selectedPerson?.role)}`}>
                        {getRoleLabel(selectedPerson?.role)}
                      </span>
                    </div>
                  </div>
                  
                  {/* Informações de contato */}
                  <div className="mb-4 lg:mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Informações de Contato</h4>
                    <div className="space-y-2">
                      <div className="flex flex-col lg:flex-row lg:justify-between">
                        <span className="text-sm text-gray-600">Email:</span>
                        <span className="text-sm font-medium break-all">{selectedPerson?.email}</span>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:justify-between">
                        <span className="text-sm text-gray-600">Telefone:</span>
                        <span className="text-sm font-medium">{selectedPerson?.phone}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Status e informações do sistema */}
                  <div className="mb-4 lg:mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">Status e Sistema</h4>
                    <div className="space-y-2">
                      <div className="flex flex-col lg:flex-row lg:justify-between">
                        <span className="text-sm text-gray-600">Subscription:</span>
                        <span className={`text-sm font-medium ${selectedPerson?.subscription === 'active' ? 'text-green-600' : 'text-red-600'}`}>
                          {selectedPerson?.subscription === 'active' ? 'Ativo' : 'Inativo'}
                        </span>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:justify-between">
                        <span className="text-sm text-gray-600">Criado em:</span>
                        <span className="text-sm font-medium">{formatCreatedAt(selectedPerson?.createdAt)}</span>
                      </div>
                      <div className="flex flex-col lg:flex-row lg:justify-between">
                        <span className="text-sm text-gray-600">ID do usuário:</span>
                        <span className="text-sm font-medium text-gray-500 break-all">{selectedPerson?._id}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Ações */}
                  <div className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2">
                    <button 
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={(e) => {
                        handleModalClose();
                        handleEditClick(e, selectedPerson);
                      }}
                    >
                      Editar Usuário
                    </button>
                    <button 
                      className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex-1"
                      onClick={() => {
                        if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
                          confirmDeleteUser(selectedPerson?._id);
                          handleModalClose();
                        }
                      }}
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Ao clicar pra apagar uma imagem: */}

            {selectedDelete && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center">
              <div className="bg-white p-5 rounded-lg w-100">
                <h2 className="text-xl mt-10 font-semibold mb-2">
                  Deseja apagar esta imagem do usuário?
                </h2>
                <img
                    className="h-40 w-40 mx-auto flex-none rounded-md bg-gray-50 mb-5 mt-5"
                    src={selectedDelete?.uri || '/default-avatar.png'}
                    alt={selectedDelete?.filename}
                />
                <h2 className="text-md mt-10 font-semibold">
                  ID da imagem:
                </h2>
                <p className="mb-2">{selectedDelete?._id}</p>
                <div className="flex items-center justify-between w-80 mx-auto mt-10 mb-8">
                          <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={() => confirmDeleteImage(selectedDelete?._id)}>
                          Sim, quero apagar
                          </button>
                          <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={() => setSelectedDelete(null)}>
                          Não, desisto
                          </button>
                      </div>
              </div>
            </div>
            )}

              {/* Ao clicar pra deletar conta de um usuário: */}

            {selectedDeleteUser && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-75 flex justify-center items-center">
              <div className="bg-white p-5 rounded-lg w-100">
                <h2 className="text-xl mt-10 font-semibold mb-2">
                  Deseja apagar este usuário?
                </h2>
                <img
                    className="h-40 w-40 mx-auto flex-none rounded-md bg-gray-50 mb-5 mt-5"
                    src={selectedDeleteUser?.profile_pic?.[0]?.uri || '/default-avatar.png'}
                    alt={selectedDeleteUser?.name}
                />
                <h2 className="text-md mt-10 font-semibold">
                  ID do usuário:
                </h2>
                <p className="mb-2">{selectedDeleteUser?._id}</p>
                <div className="flex items-center justify-between w-80 mx-auto mt-10 mb-8">
                          <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={() => confirmDeleteUser(selectedDeleteUser?._id)}>
                          Sim, quero apagar
                          </button>
                          <button className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" onClick={() => setSelectedDeleteUser(null)}>
                          Não, desisto
                          </button>
                      </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
